import React, { Component } from 'react'
import { connect } from 'react-redux';

class Header extends Component {
  render() {
    return (
      <header>
        <div className='logo'>
          <a href='https://www.myinsurancebroker.com'><img src="https://www.myinsurancebroker.com/resources/img/mib--logo.png" alt="mib Logo" /></a>
          {(this.props.showEntutiveLogo)&&(<a href='https://entuitivecompliance.com/'><img src="https://api.myinsurancebroker.com/uploads/Recurso_46_61565de35e.svg" alt="Entuitive Logo" /></a>)}
        </div>
        <div className='contact'><a className='button' href={'tel:'+this.props.contactPhoneNumber}>Contact Us</a></div>
      </header>
    )
  }
}
const mapStateToProps = (state) => ({
  contactPhoneNumber:state.ui.contactPhoneNumber,
  showEntutiveLogo:state.ui.showEntutiveLogo
});
export default connect(mapStateToProps,null)(Header)